import MountService from "./MountService";

module.exports = {
  MountService: new MountService()
};



// WEBPACK FOOTER //
// ./packages/foundation-ui/src/mount/index.js